module.exports = __webpack_public_path__ + "static/pattern-ui-common-scales-b6f2b16e75de5027e5c874a3fbd9d004.png";